export default __webpack_public_path__ + "static/undraw_having_fun_re_vj4h-4fd4d0ec7759b4715938a75f17e55485.svg";